import React from 'react';
import './LiveAnnouncerMessage.scss';

export type LiveAnnouncerMessageProps = {
  message: string;
  ariaLive: 'polite' | 'assertive';
};

export default function LiveAnnouncerMessage({ message, ariaLive }: LiveAnnouncerMessageProps) {
  return (
    <div aria-live={ariaLive} aria-relevant="all" aria-atomic="true" className="live-announcer-message">
      {message}
    </div>
  );
}
